import { find } from 'lodash-es'
import { IAppState } from 'core/store/store'
import { createDeepEqualSelector } from 'core/utils/helpers'
import { IAuditLogsEvent } from '../audit-logs/AuditLogs.types'

const getAuditEventTypes = (state: IAppState): IAuditLogsEvent[] => state.auditEvents.items
const getIdAuditEvent = (state: IAppState, props: any): string => props.match.params.id

export const getEvent = createDeepEqualSelector(
  [getAuditEventTypes, getIdAuditEvent],
  (events: IAuditLogsEvent[], id: string): any => find(events, ['id', id])
)
